import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import type { FormattedDetails, FormattedName } from '../../../../onboarding-business-insight.types';
import BusinessNameList from './components/business-name-list';
import OtherBusinessDetails from './components/other-business-details';
type BusinessDetailsProps = {
  names: FormattedName[];
  details: FormattedDetails;
  onClick: (registrationId: string) => void;
};
const BusinessDetails = t0 => {
  const $ = _c(8);
  const {
    names,
    details,
    onClick
  } = t0;
  let t1;
  if ($[0] !== names || $[1] !== onClick) {
    t1 = <BusinessNameList data={names} onOpen={onClick} />;
    $[0] = names;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== details) {
    t2 = <Card.Body className="px-4 pt-2.75 pb-4"><OtherBusinessDetails data={details} /></Card.Body>;
    $[3] = details;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex flex-col gap-1">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default BusinessDetails;